export default __webpack_public_path__ + "locales/it/Ldap.json?hash=77187a5adcb2fcba7cf40a65983ecceb";